import yup from '../../../config/yup';

export const microsoftCosmosDbV2ReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('microsoftCosmosDbV2Reader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    databaseId: yup.string(),
    collectionId: yup.string(),
    accountKey: yup.string(),
    accountEndpoint: yup.string(),
    consistencyLevel: yup.string(),
    httpProxy: yup.string(),
    pageSize: yup.number().positive('Page Size must be a positive number'),
    query: yup.string().required('Query is required'),
  }),
});
